import axios from 'axios';

const contextsService = {
	fetchAllContexts: () => axios.get(`api/v1/contexts`)
};

export default contextsService;
